<template>
  <div class="flex justif1y-between pr-2 h-8 items-center">
    <!-- 条件 -->
    <div>条件</div>
    <div class="ml-2">
      <a-select
        :options="compareTypeOptions"
        :value="compare.type"
        class="w-20"
        size="small"
        placeholder="请选择"
        @change="(val: Compare['type'])=> emits('change', val)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useIfttt } from '@/hooks/use-ifttt';
import { PropType } from 'vue';

defineProps({
  compare: {
    type: Object as PropType<Compare>,
    required: true
  }
});

const emits = defineEmits<{
  (event: 'change', val: Compare['type']): void;
}>();

const { compareTypeOptions } = useIfttt();
</script>

<style lang="less" scoped></style>
